"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterSection = exports.HeaderSection = void 0;
var react_1 = __importDefault(require("react"));
var headerOrFooterText = function (props) {
    var text = '';
    if (props.sections) {
        for (var i = 0; i <= 2; i++) {
            if (props.sections[i].content) {
                props.sections[i].content.blocks.map(function (e) {
                    var str = e.text;
                    if (str.length > 1) {
                        text += "".concat(str.trim(), "\n");
                    }
                });
                if (text.length > 1) {
                    return text;
                }
                else {
                    text = '';
                }
            }
        }
    }
    return text;
};
function HeaderSection(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { whiteSpace: 'pre-wrap' }, className: "w-100" },
            react_1.default.createElement("strong", null, headerOrFooterText(props.content)))));
}
exports.HeaderSection = HeaderSection;
;
function FooterSection(props) {
    return (react_1.default.createElement("div", { className: "relative pv1" },
        react_1.default.createElement("div", { style: { whiteSpace: 'pre-wrap' } }, headerOrFooterText(props.content)),
        react_1.default.createElement("div", { className: "pt2" },
            react_1.default.createElement("p", { className: "f6" },
                "Registered to ",
                react_1.default.createElement("b", { className: "ttu" }, props.doctor),
                react_1.default.createElement("br", null),
                "\u00A9 2020 ",
                react_1.default.createElement("b", { className: "ttu" }, "DOCTORKOI"),
                ", All Rights Reserved"),
            react_1.default.createElement("p", null,
                "To book your appointment please call ",
                react_1.default.createElement("strong", { className: "dark-blue" }, "+8809666777711"),
                " or ",
                react_1.default.createElement("br", null),
                "visit our website: ",
                react_1.default.createElement("span", { className: "dark-blue" }, "www.doctorkoi.com"),
                " & facebook page: ",
                react_1.default.createElement("span", { className: "dark-blue" }, "https://www.facebook.com/doctorkoiofficial")))));
}
exports.FooterSection = FooterSection;
;
//# sourceMappingURL=HeaderAndFooter.js.map